// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27%3E%3Cpath d=%27M1 1l5 5 5-5%27 stroke=%27%23c8a84b%27 stroke-width=%271.5%27 fill=%27none%27 stroke-linecap=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* ── Variables ───────────────────────────────────────────────── */
:root {
  --bg-void:    #0b0c0e;
  --bg-deep:    #111317;
  --bg-surface: #191c22;
  --bg-raised:  #20242d;
  --bg-input:   #161920;
  --border:     rgba(180, 150, 80, 0.18);
  --border-hi:  rgba(180, 150, 80, 0.45);
  --gold-dim:   #7a6030;
  --gold:       #c8a84b;
  --gold-bright:#e8c96e;
  --text-primary: #d4c9a8;
  --text-muted:   #6e6858;
  --text-dim:     #9a9080;
  --red:        #c04040;
  --red-dim:    #7a2828;
  --font-display: "Cinzel", serif;
  --font-body:    "Crimson Pro", Georgia, serif;
  --radius:    4px;
  --radius-lg: 8px;
}

/* ── Utility ─────────────────────────────────────────────────── */
.hidden { display: none !important; }

/* ── Base ────────────────────────────────────────────────────── */
html, body {
  background: var(--bg-void);
  color: var(--text-primary);
  font-family: var(--font-body);
  font-size: 19px;
  line-height: 1.65;
  min-height: 100vh;
}

body::before {
  content: "";
  position: fixed;
  inset: 0;
  background-image: radial-gradient(
    ellipse 80% 60% at 50% -10%,
    rgba(200, 168, 75, 0.06) 0%,
    transparent 70%
  );
  pointer-events: none;
  z-index: 0;
}

body > * {
  position: relative;
  z-index: 1;
}

/* ── Header ──────────────────────────────────────────────────── */
.header-container {
  border-bottom: 1px solid var(--border);
  padding: 2.5rem 2rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  background: linear-gradient(180deg, rgba(200, 168, 75, 0.04) 0%, transparent 100%);
}

.header-ornament {
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  max-width: 720px;
  justify-content: center;
}

.header-ornament::before,
.header-ornament::after {
  content: "";
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, var(--border-hi));
}
.header-ornament::after {
  background: linear-gradient(270deg, transparent, var(--border-hi));
}

.diamond {
  width: 8px;
  height: 8px;
  background: var(--gold);
  transform: rotate(45deg);
  flex-shrink: 0;
}

.header {
  font-family: var(--font-display);
  font-size: clamp(1.2rem, 3vw, 1.8rem);
  font-weight: 600;
  color: var(--gold-bright);
  text-align: center;
  letter-spacing: 0.08em;
}

.about-section {
  font-size: 1rem;
  color: var(--text-dim);
  font-style: italic;
  text-align: center;
  max-width: 560px;
  font-weight: 300;
}

.rate-badge {
  display: none;
  align-items: center;
  gap: 4px;
  font-size: 0.85rem;
  color: var(--text-muted);
  font-style: italic;
}
.rate-badge:not(.hidden) { display: flex; }
.rate-badge span { color: var(--gold-dim); }

/* ── Layout ──────────────────────────────────────────────────── */
main {
  display: grid;
  grid-template-columns: 300px 1fr;
  max-width: 1280px;
  margin: 0 auto;
  min-height: calc(100vh - 150px);
}

/* ── Sidebar ─────────────────────────────────────────────────── */
.settings {
  border-right: 1px solid var(--border);
  padding: 1.75rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background: rgba(0, 0, 0, 0.15);
}

.sidebar-title {
  font-family: var(--font-display);
  font-size: 0.75rem;
  letter-spacing: 0.2em;
  color: var(--gold-dim);
  text-transform: uppercase;
}

.divider {
  height: 1px;
  background: var(--border);
}

/* ── Form Fields ─────────────────────────────────────────────── */
.field-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

label {
  font-size: 0.8rem;
  letter-spacing: 0.1em;
  color: var(--text-dim);
  text-transform: uppercase;
  font-family: var(--font-display);
  font-weight: 400;
}

select,
input[type="text"],
input[type="password"],
input[type="number"] {
  width: 100%;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--text-primary);
  font-family: var(--font-body);
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  appearance: none;
  -webkit-appearance: none;
}

select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  padding-right: 2rem;
}

select:focus,
input[type="text"]:focus,
input[type="password"]:focus,
input[type="number"]:focus {
  border-color: var(--gold-dim);
  box-shadow: 0 0 0 3px rgba(200, 168, 75, 0.08);
}

select option {
  background: var(--bg-deep);
  color: var(--text-primary);
}

.field-hint {
  font-size: 0.78rem;
  color: var(--text-muted);
  font-style: italic;
  line-height: 1.4;
}

.field-hint a {
  color: var(--gold-dim);
  text-decoration: none;
  transition: color 0.2s;
}
.field-hint a:hover { color: var(--gold); }

/* ── Buttons ─────────────────────────────────────────────────── */
.run-btn {
  width: 100%;
  padding: 0.65rem 1rem;
  background: transparent;
  border: 1px solid var(--gold-dim);
  border-radius: var(--radius);
  color: var(--gold);
  font-family: var(--font-display);
  font-size: 0.78rem;
  letter-spacing: 0.15em;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.run-btn:hover:not(:disabled) {
  background: rgba(200, 168, 75, 0.08);
  border-color: var(--gold);
  color: var(--gold-bright);
  box-shadow: 0 0 20px rgba(200, 168, 75, 0.1);
}
.run-btn:active:not(:disabled) { transform: scale(0.98); }
.run-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.btn-icon {
  width: 0;
  height: 0;
  border-left: 8px solid var(--gold);
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  transition: border-left-color 0.2s;
  flex-shrink: 0;
}
.run-btn:hover .btn-icon { border-left-color: var(--gold-bright); }

.stop-btn {
  width: 100%;
  padding: 0.5rem 1rem;
  background: transparent;
  border: 1px solid var(--red-dim);
  border-radius: var(--radius);
  color: var(--red);
  font-family: var(--font-display);
  font-size: 0.75rem;
  letter-spacing: 0.15em;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s;
}
.stop-btn:hover {
  background: rgba(192, 64, 64, 0.1);
  border-color: var(--red);
}

.export-btn {
  width: 100%;
  padding: 0.5rem 1rem;
  background: transparent;
  border: 1px solid var(--gold-dim);
  border-radius: var(--radius);
  color: var(--gold-dim);
  font-family: var(--font-display);
  font-size: 0.75rem;
  letter-spacing: 0.15em;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
}
.export-btn:hover {
  background: rgba(200, 168, 75, 0.06);
  border-color: var(--gold);
  color: var(--gold);
}

.text-link-btn {
  background: transparent;
  border: none;
  color: var(--gold-dim);
  text-align: left;
  padding: 0;
  font-size: 0.9rem;
  font-style: italic;
  cursor: pointer;
}
.text-link-btn:hover { color: var(--gold); }

/* ── Results Panel ───────────────────────────────────────────── */
.results {
  padding: 1.75rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

/* ── Error Banner ────────────────────────────────────────────── */
.error-banner {
  display: none;
  background: rgba(192, 64, 64, 0.08);
  border: 1px solid var(--red-dim);
  border-radius: var(--radius);
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  color: #e08080;
  font-style: italic;
}
.error-banner.visible { display: block; }

/* ── Progress ────────────────────────────────────────────────── */
.progress-area {
  flex-direction: column;
  gap: 0.6rem;
}
.progress-area:not(.hidden) { display: flex; }

.progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.progress-label {
  font-size: 0.8rem;
  color: var(--text-dim);
  letter-spacing: 0.08em;
  font-family: var(--font-display);
}

.progress-count {
  font-size: 0.8rem;
  color: var(--gold-dim);
  font-family: var(--font-display);
}

.progress-track {
  height: 3px;
  background: var(--bg-raised);
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--gold-dim), var(--gold));
  width: 0%;
  transition: width 0.4s ease;
  border-radius: 2px;
}

.progress-current {
  font-size: 0.85rem;
  color: var(--text-muted);
  font-style: italic;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fetching-badge {
  font-size: 0.8rem;
  color: var(--gold-dim);
  font-style: italic;
  font-family: var(--font-display);
  letter-spacing: 0.05em;
  animation: pulse 1.5s ease-in-out infinite;
}

/* ── Top Results ─────────────────────────────────────────────── */
.top-results-area {
  flex-direction: column;
  gap: 1rem;
}
.top-results-area:not(.hidden) { display: flex; }

.section-title {
  font-family: var(--font-display);
  font-size: 0.72rem;
  letter-spacing: 0.2em;
  color: var(--gold-dim);
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.section-title::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--border);
}

.top-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1rem;
}

.result-card {
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 1rem 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  transition: border-color 0.2s, box-shadow 0.2s;
  position: relative;
  overflow: hidden;
}
.result-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(200, 168, 75, 0.04) 0%, transparent 60%);
  pointer-events: none;
}
.result-card:hover {
  border-color: var(--border-hi);
  box-shadow: 0 0 20px rgba(200, 168, 75, 0.06);
}

.card-rank {
  font-family: var(--font-display);
  font-size: 0.65rem;
  letter-spacing: 0.15em;
  color: var(--gold-dim);
}

.card-notables {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.notable-tag {
  font-size: 0.9rem;
  color: var(--text-primary);
  font-style: italic;
}
.notable-tag::before {
  content: "◆";
  font-size: 0.55rem;
  color: var(--gold-dim);
  margin-right: 6px;
  font-style: normal;
  vertical-align: middle;
}

.card-stats {
  display: flex;
  gap: 1.25rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--border);
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stat-label {
  font-size: 0.7rem;
  letter-spacing: 0.1em;
  color: var(--text-muted);
  text-transform: uppercase;
  font-family: var(--font-display);
}

.stat-value {
  font-size: 1.05rem;
  color: var(--gold-bright);
}
.stat-value.chaos::after {
  content: "c";
  font-size: 0.7rem;
  color: var(--gold-dim);
  margin-left: 2px;
}

.card-link {
  font-size: 0.78rem;
  color: var(--gold-dim);
  text-decoration: none;
  font-family: var(--font-display);
  letter-spacing: 0.08em;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: color 0.2s;
  width: fit-content;
}
.card-link:hover { color: var(--gold); }
.card-link::after { content: " ↗"; font-size: 0.7rem; }

/* ── Log Table ───────────────────────────────────────────────── */
.log-area {
  flex-direction: column;
  gap: 0.75rem;
}
.log-area:not(.hidden) { display: flex; }

.sort-btns {
  display: flex;
  gap: 6px;
  flex-shrink: 0;
}

.sort-btn {
  background: transparent;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--text-muted);
  font-family: var(--font-display);
  font-size: 0.65rem;
  letter-spacing: 0.1em;
  padding: 0.3rem 0.65rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
  text-transform: uppercase;
}
.sort-btn:hover { border-color: var(--gold-dim); color: var(--gold-dim); }
.sort-btn.active { border-color: var(--gold-dim); color: var(--gold); }

.log-scroll {
  max-height: 380px;
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--bg-deep);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}
.log-scroll::-webkit-scrollbar { width: 5px; }
.log-scroll::-webkit-scrollbar-track { background: transparent; }
.log-scroll::-webkit-scrollbar-thumb { background: var(--gold-dim); border-radius: 3px; }

.log-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
  table-layout: fixed;
}

.log-table col:nth-child(1) { width: 36px; }
.log-table col:nth-child(2) { width: auto; }
.log-table col:nth-child(3) { width: 80px; }
.log-table col:nth-child(4) { width: 90px; }
.log-table col:nth-child(5) { width: 70px; }

.log-table thead tr { border-bottom: 1px solid var(--border); }

.log-table th {
  padding: 0.5rem 0.75rem;
  text-align: left;
  font-family: var(--font-display);
  font-size: 0.65rem;
  letter-spacing: 0.12em;
  color: var(--gold-dim);
  font-weight: 400;
  text-transform: uppercase;
  white-space: nowrap;
}

.log-table td {
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid rgba(180, 150, 80, 0.06);
  color: var(--text-dim);
  vertical-align: middle;
}

.log-table th:nth-child(3),
.log-table th:nth-child(4),
.log-table td:nth-child(3),
.log-table td:nth-child(4) { text-align: right; }

.log-table th:nth-child(5),
.log-table td:nth-child(5) { text-align: center; white-space: nowrap; }

.log-table tr:hover td { background: rgba(200, 168, 75, 0.03); }
.log-table tr:last-child td { border-bottom: none; }
.log-table .td-combo { color: var(--text-primary); font-style: italic; }
.log-table .td-price { color: var(--gold); text-align: right; }
.log-table .td-total { text-align: right; }

/* ── Empty State ─────────────────────────────────────────────── */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 5rem 2rem;
  color: var(--text-muted);
  text-align: center;
}

.empty-glyph {
  width: 48px;
  height: 48px;
  border: 1px solid var(--border);
  transform: rotate(45deg);
  display: flex;
  align-items: center;
  justify-content: center;
}

.empty-glyph-inner {
  width: 16px;
  height: 16px;
  background: var(--gold-dim);
  opacity: 0.5;
}

.empty-state p {
  font-style: italic;
  font-size: 1rem;
  max-width: 300px;
}

/* ── Spinner ─────────────────────────────────────────────────── */
.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid var(--gold-dim);
  border-top: 2px solid var(--gold-bright);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 8px;
}

/* ── Animations ──────────────────────────────────────────────── */
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* ── Responsive ──────────────────────────────────────────────── */
@media (max-width: 720px) {
  main { grid-template-columns: 1fr; }
  .settings { border-right: none; border-bottom: 1px solid var(--border); }
}

.modal {
  width: min(92vw, 420px);
  background: var(--bg-surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 10px 40px rgba(0,0,0,0.5);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.modal-title {
  font-family: var(--font-display);
  font-size: 1rem;
  color: var(--gold);
  letter-spacing: 0.08em;
}
.modal-desc {
  font-size: 0.9rem;
  color: var(--text-dim);
}
.modal input[type="text"],
.modal input[type="password"] {
  background: var(--bg-input);
  border: 1px solid var(--border);
  color: var(--text-primary);
  border-radius: var(--radius);
}
.modal input::placeholder {
  color: var(--text-muted);
  opacity: 0.8;
}
.modal-desc { margin-bottom: 0.25rem; }
.modal-error {
  font-size: 0.85rem;
  color: #e08080;
  background: rgba(192,64,64,0.08);
  border: 1px solid var(--red-dim);
  border-radius: var(--radius);
  padding: 0.5rem 0.6rem;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,mEAAmE;AACnE;EACE,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,sCAAsC;EACtC,sCAAsC;EACtC,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,6CAA6C;EAC7C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE,UAAU,wBAAwB,EAAE;;AAEpC,mEAAmE;AACnE;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR;;;;GAIC;EACD,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,mEAAmE;AACnE;EACE,sCAAsC;EACtC,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,OAAO;EACP,WAAW;EACX,iEAAiE;AACnE;AACA;EACE,kEAAkE;AACpE;;AAEA;EACE,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;AACA,2BAA2B,aAAa,EAAE;AAC1C,mBAAmB,sBAAsB,EAAE;;AAE3C,mEAAmE;AACnE;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA,mEAAmE;AACnE;EACE,qCAAqC;EACrC,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;;;EAIE,WAAW;EACX,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,8CAA8C;EAC9C,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,yDAA6N;EAC7N,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;;;EAIE,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;AACA,sBAAsB,kBAAkB,EAAE;;AAE1C,mEAAmE;AACnE;EACE,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2EAA2E;EAC3E,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,yBAAyB;EACzB,4CAA4C;AAC9C;AACA,iCAAiC,sBAAsB,EAAE;AACzD,oBAAoB,YAAY,EAAE,mBAAmB,EAAE;;AAEvD;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,iCAAiC;EACjC,oCAAoC;EACpC,kCAAkC;EAClC,cAAc;AAChB;AACA,2BAA2B,qCAAqC,EAAE;;AAElE;EACE,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;EAC5B,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,8CAA8C;AAChD;AACA;EACE,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,uBAAuB;EACvB,iCAAiC;EACjC,4BAA4B;EAC5B,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;AACA,uBAAuB,kBAAkB,EAAE;;AAE3C,mEAAmE;AACnE;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mCAAmC;EACnC,gCAAgC;EAChC,4BAA4B;EAC5B,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA,wBAAwB,cAAc,EAAE;;AAExC,mEAAmE;AACnE;EACE,sBAAsB;EACtB,WAAW;AACb;AACA,8BAA8B,aAAa,EAAE;;AAE7C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gEAAgE;EAChE,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,mEAAmE;AACnE;EACE,sBAAsB;EACtB,SAAS;AACX;AACA,iCAAiC,aAAa,EAAE;;AAEhD;EACE,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW;EACX,OAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iFAAiF;EACjF,oBAAoB;AACtB;AACA;EACE,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,wBAAwB;EACxB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;AACpB;AACA,mBAAmB,kBAAkB,EAAE;AACvC,oBAAoB,aAAa,EAAE,iBAAiB,EAAE;;AAEtD,mEAAmE;AACnE;EACE,sBAAsB;EACtB,YAAY;AACd;AACA,yBAAyB,aAAa,EAAE;;AAExC;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,wBAAwB;EACxB,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;AACA,kBAAkB,6BAA6B,EAAE,sBAAsB,EAAE;AACzE,mBAAmB,6BAA6B,EAAE,kBAAkB,EAAE;;AAEtE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA,iCAAiC,UAAU,EAAE;AAC7C,uCAAuC,uBAAuB,EAAE;AAChE,uCAAuC,2BAA2B,EAAE,kBAAkB,EAAE;;AAExF;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,8BAA8B,WAAW,EAAE;AAC3C,8BAA8B,WAAW,EAAE;AAC3C,8BAA8B,WAAW,EAAE;AAC3C,8BAA8B,WAAW,EAAE;AAC3C,8BAA8B,WAAW,EAAE;;AAE3C,sBAAsB,sCAAsC,EAAE;;AAE9D;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;EACjD,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;;;6BAG6B,iBAAiB,EAAE;;AAEhD;6BAC6B,kBAAkB,EAAE,mBAAmB,EAAE;;AAEtE,yBAAyB,oCAAoC,EAAE;AAC/D,8BAA8B,mBAAmB,EAAE;AACnD,uBAAuB,0BAA0B,EAAE,kBAAkB,EAAE;AACvE,uBAAuB,kBAAkB,EAAE,iBAAiB,EAAE;AAC9D,uBAAuB,iBAAiB,EAAE;;AAE1C,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mEAAmE;AACnE;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,wCAAwC;EACxC,kBAAkB;EAClB,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,mEAAmE;AACnE;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,mEAAmE;AACnE;EACE,OAAO,0BAA0B,EAAE;EACnC,YAAY,kBAAkB,EAAE,sCAAsC,EAAE;AAC1E;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;;EAEE,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;EAC1B,4BAA4B;AAC9B;AACA;EACE,wBAAwB;EACxB,YAAY;AACd;AACA,cAAc,sBAAsB,EAAE;AACtC;EACE,kBAAkB;EAClB,cAAc;EACd,gCAAgC;EAChC,gCAAgC;EAChC,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":["*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* ── Variables ───────────────────────────────────────────────── */\n:root {\n  --bg-void:    #0b0c0e;\n  --bg-deep:    #111317;\n  --bg-surface: #191c22;\n  --bg-raised:  #20242d;\n  --bg-input:   #161920;\n  --border:     rgba(180, 150, 80, 0.18);\n  --border-hi:  rgba(180, 150, 80, 0.45);\n  --gold-dim:   #7a6030;\n  --gold:       #c8a84b;\n  --gold-bright:#e8c96e;\n  --text-primary: #d4c9a8;\n  --text-muted:   #6e6858;\n  --text-dim:     #9a9080;\n  --red:        #c04040;\n  --red-dim:    #7a2828;\n  --font-display: \"Cinzel\", serif;\n  --font-body:    \"Crimson Pro\", Georgia, serif;\n  --radius:    4px;\n  --radius-lg: 8px;\n}\n\n/* ── Utility ─────────────────────────────────────────────────── */\n.hidden { display: none !important; }\n\n/* ── Base ────────────────────────────────────────────────────── */\nhtml, body {\n  background: var(--bg-void);\n  color: var(--text-primary);\n  font-family: var(--font-body);\n  font-size: 19px;\n  line-height: 1.65;\n  min-height: 100vh;\n}\n\nbody::before {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  background-image: radial-gradient(\n    ellipse 80% 60% at 50% -10%,\n    rgba(200, 168, 75, 0.06) 0%,\n    transparent 70%\n  );\n  pointer-events: none;\n  z-index: 0;\n}\n\nbody > * {\n  position: relative;\n  z-index: 1;\n}\n\n/* ── Header ──────────────────────────────────────────────────── */\n.header-container {\n  border-bottom: 1px solid var(--border);\n  padding: 2.5rem 2rem 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n  background: linear-gradient(180deg, rgba(200, 168, 75, 0.04) 0%, transparent 100%);\n}\n\n.header-ornament {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  width: 100%;\n  max-width: 720px;\n  justify-content: center;\n}\n\n.header-ornament::before,\n.header-ornament::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, var(--border-hi));\n}\n.header-ornament::after {\n  background: linear-gradient(270deg, transparent, var(--border-hi));\n}\n\n.diamond {\n  width: 8px;\n  height: 8px;\n  background: var(--gold);\n  transform: rotate(45deg);\n  flex-shrink: 0;\n}\n\n.header {\n  font-family: var(--font-display);\n  font-size: clamp(1.2rem, 3vw, 1.8rem);\n  font-weight: 600;\n  color: var(--gold-bright);\n  text-align: center;\n  letter-spacing: 0.08em;\n}\n\n.about-section {\n  font-size: 1rem;\n  color: var(--text-dim);\n  font-style: italic;\n  text-align: center;\n  max-width: 560px;\n  font-weight: 300;\n}\n\n.rate-badge {\n  display: none;\n  align-items: center;\n  gap: 4px;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  font-style: italic;\n}\n.rate-badge:not(.hidden) { display: flex; }\n.rate-badge span { color: var(--gold-dim); }\n\n/* ── Layout ──────────────────────────────────────────────────── */\nmain {\n  display: grid;\n  grid-template-columns: 300px 1fr;\n  max-width: 1280px;\n  margin: 0 auto;\n  min-height: calc(100vh - 150px);\n}\n\n/* ── Sidebar ─────────────────────────────────────────────────── */\n.settings {\n  border-right: 1px solid var(--border);\n  padding: 1.75rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  background: rgba(0, 0, 0, 0.15);\n}\n\n.sidebar-title {\n  font-family: var(--font-display);\n  font-size: 0.75rem;\n  letter-spacing: 0.2em;\n  color: var(--gold-dim);\n  text-transform: uppercase;\n}\n\n.divider {\n  height: 1px;\n  background: var(--border);\n}\n\n/* ── Form Fields ─────────────────────────────────────────────── */\n.field-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\nlabel {\n  font-size: 0.8rem;\n  letter-spacing: 0.1em;\n  color: var(--text-dim);\n  text-transform: uppercase;\n  font-family: var(--font-display);\n  font-weight: 400;\n}\n\nselect,\ninput[type=\"text\"],\ninput[type=\"password\"],\ninput[type=\"number\"] {\n  width: 100%;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--text-primary);\n  font-family: var(--font-body);\n  font-size: 1rem;\n  padding: 0.5rem 0.75rem;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\nselect {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23c8a84b' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  padding-right: 2rem;\n}\n\nselect:focus,\ninput[type=\"text\"]:focus,\ninput[type=\"password\"]:focus,\ninput[type=\"number\"]:focus {\n  border-color: var(--gold-dim);\n  box-shadow: 0 0 0 3px rgba(200, 168, 75, 0.08);\n}\n\nselect option {\n  background: var(--bg-deep);\n  color: var(--text-primary);\n}\n\n.field-hint {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  font-style: italic;\n  line-height: 1.4;\n}\n\n.field-hint a {\n  color: var(--gold-dim);\n  text-decoration: none;\n  transition: color 0.2s;\n}\n.field-hint a:hover { color: var(--gold); }\n\n/* ── Buttons ─────────────────────────────────────────────────── */\n.run-btn {\n  width: 100%;\n  padding: 0.65rem 1rem;\n  background: transparent;\n  border: 1px solid var(--gold-dim);\n  border-radius: var(--radius);\n  color: var(--gold);\n  font-family: var(--font-display);\n  font-size: 0.78rem;\n  letter-spacing: 0.15em;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s, color 0.2s, box-shadow 0.2s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n.run-btn:hover:not(:disabled) {\n  background: rgba(200, 168, 75, 0.08);\n  border-color: var(--gold);\n  color: var(--gold-bright);\n  box-shadow: 0 0 20px rgba(200, 168, 75, 0.1);\n}\n.run-btn:active:not(:disabled) { transform: scale(0.98); }\n.run-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n.btn-icon {\n  width: 0;\n  height: 0;\n  border-left: 8px solid var(--gold);\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  transition: border-left-color 0.2s;\n  flex-shrink: 0;\n}\n.run-btn:hover .btn-icon { border-left-color: var(--gold-bright); }\n\n.stop-btn {\n  width: 100%;\n  padding: 0.5rem 1rem;\n  background: transparent;\n  border: 1px solid var(--red-dim);\n  border-radius: var(--radius);\n  color: var(--red);\n  font-family: var(--font-display);\n  font-size: 0.75rem;\n  letter-spacing: 0.15em;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s;\n}\n.stop-btn:hover {\n  background: rgba(192, 64, 64, 0.1);\n  border-color: var(--red);\n}\n\n.export-btn {\n  width: 100%;\n  padding: 0.5rem 1rem;\n  background: transparent;\n  border: 1px solid var(--gold-dim);\n  border-radius: var(--radius);\n  color: var(--gold-dim);\n  font-family: var(--font-display);\n  font-size: 0.75rem;\n  letter-spacing: 0.15em;\n  cursor: pointer;\n  transition: background 0.2s, border-color 0.2s, color 0.2s;\n}\n.export-btn:hover {\n  background: rgba(200, 168, 75, 0.06);\n  border-color: var(--gold);\n  color: var(--gold);\n}\n\n.text-link-btn {\n  background: transparent;\n  border: none;\n  color: var(--gold-dim);\n  text-align: left;\n  padding: 0;\n  font-size: 0.9rem;\n  font-style: italic;\n  cursor: pointer;\n}\n.text-link-btn:hover { color: var(--gold); }\n\n/* ── Results Panel ───────────────────────────────────────────── */\n.results {\n  padding: 1.75rem 2rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n/* ── Error Banner ────────────────────────────────────────────── */\n.error-banner {\n  display: none;\n  background: rgba(192, 64, 64, 0.08);\n  border: 1px solid var(--red-dim);\n  border-radius: var(--radius);\n  padding: 0.75rem 1rem;\n  font-size: 0.9rem;\n  color: #e08080;\n  font-style: italic;\n}\n.error-banner.visible { display: block; }\n\n/* ── Progress ────────────────────────────────────────────────── */\n.progress-area {\n  flex-direction: column;\n  gap: 0.6rem;\n}\n.progress-area:not(.hidden) { display: flex; }\n\n.progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.progress-label {\n  font-size: 0.8rem;\n  color: var(--text-dim);\n  letter-spacing: 0.08em;\n  font-family: var(--font-display);\n}\n\n.progress-count {\n  font-size: 0.8rem;\n  color: var(--gold-dim);\n  font-family: var(--font-display);\n}\n\n.progress-track {\n  height: 3px;\n  background: var(--bg-raised);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--gold-dim), var(--gold));\n  width: 0%;\n  transition: width 0.4s ease;\n  border-radius: 2px;\n}\n\n.progress-current {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  font-style: italic;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fetching-badge {\n  font-size: 0.8rem;\n  color: var(--gold-dim);\n  font-style: italic;\n  font-family: var(--font-display);\n  letter-spacing: 0.05em;\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n/* ── Top Results ─────────────────────────────────────────────── */\n.top-results-area {\n  flex-direction: column;\n  gap: 1rem;\n}\n.top-results-area:not(.hidden) { display: flex; }\n\n.section-title {\n  font-family: var(--font-display);\n  font-size: 0.72rem;\n  letter-spacing: 0.2em;\n  color: var(--gold-dim);\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n.section-title::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: var(--border);\n}\n\n.top-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.result-card {\n  background: var(--bg-surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 1rem 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  transition: border-color 0.2s, box-shadow 0.2s;\n  position: relative;\n  overflow: hidden;\n}\n.result-card::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, rgba(200, 168, 75, 0.04) 0%, transparent 60%);\n  pointer-events: none;\n}\n.result-card:hover {\n  border-color: var(--border-hi);\n  box-shadow: 0 0 20px rgba(200, 168, 75, 0.06);\n}\n\n.card-rank {\n  font-family: var(--font-display);\n  font-size: 0.65rem;\n  letter-spacing: 0.15em;\n  color: var(--gold-dim);\n}\n\n.card-notables {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.notable-tag {\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  font-style: italic;\n}\n.notable-tag::before {\n  content: \"◆\";\n  font-size: 0.55rem;\n  color: var(--gold-dim);\n  margin-right: 6px;\n  font-style: normal;\n  vertical-align: middle;\n}\n\n.card-stats {\n  display: flex;\n  gap: 1.25rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid var(--border);\n}\n\n.stat {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.stat-label {\n  font-size: 0.7rem;\n  letter-spacing: 0.1em;\n  color: var(--text-muted);\n  text-transform: uppercase;\n  font-family: var(--font-display);\n}\n\n.stat-value {\n  font-size: 1.05rem;\n  color: var(--gold-bright);\n}\n.stat-value.chaos::after {\n  content: \"c\";\n  font-size: 0.7rem;\n  color: var(--gold-dim);\n  margin-left: 2px;\n}\n\n.card-link {\n  font-size: 0.78rem;\n  color: var(--gold-dim);\n  text-decoration: none;\n  font-family: var(--font-display);\n  letter-spacing: 0.08em;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  transition: color 0.2s;\n  width: fit-content;\n}\n.card-link:hover { color: var(--gold); }\n.card-link::after { content: \" ↗\"; font-size: 0.7rem; }\n\n/* ── Log Table ───────────────────────────────────────────────── */\n.log-area {\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.log-area:not(.hidden) { display: flex; }\n\n.sort-btns {\n  display: flex;\n  gap: 6px;\n  flex-shrink: 0;\n}\n\n.sort-btn {\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--text-muted);\n  font-family: var(--font-display);\n  font-size: 0.65rem;\n  letter-spacing: 0.1em;\n  padding: 0.3rem 0.65rem;\n  cursor: pointer;\n  transition: border-color 0.2s, color 0.2s;\n  text-transform: uppercase;\n}\n.sort-btn:hover { border-color: var(--gold-dim); color: var(--gold-dim); }\n.sort-btn.active { border-color: var(--gold-dim); color: var(--gold); }\n\n.log-scroll {\n  max-height: 380px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: var(--bg-deep);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n}\n.log-scroll::-webkit-scrollbar { width: 5px; }\n.log-scroll::-webkit-scrollbar-track { background: transparent; }\n.log-scroll::-webkit-scrollbar-thumb { background: var(--gold-dim); border-radius: 3px; }\n\n.log-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.88rem;\n  table-layout: fixed;\n}\n\n.log-table col:nth-child(1) { width: 36px; }\n.log-table col:nth-child(2) { width: auto; }\n.log-table col:nth-child(3) { width: 80px; }\n.log-table col:nth-child(4) { width: 90px; }\n.log-table col:nth-child(5) { width: 70px; }\n\n.log-table thead tr { border-bottom: 1px solid var(--border); }\n\n.log-table th {\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n  font-family: var(--font-display);\n  font-size: 0.65rem;\n  letter-spacing: 0.12em;\n  color: var(--gold-dim);\n  font-weight: 400;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.log-table td {\n  padding: 0.5rem 0.75rem;\n  border-bottom: 1px solid rgba(180, 150, 80, 0.06);\n  color: var(--text-dim);\n  vertical-align: middle;\n}\n\n.log-table th:nth-child(3),\n.log-table th:nth-child(4),\n.log-table td:nth-child(3),\n.log-table td:nth-child(4) { text-align: right; }\n\n.log-table th:nth-child(5),\n.log-table td:nth-child(5) { text-align: center; white-space: nowrap; }\n\n.log-table tr:hover td { background: rgba(200, 168, 75, 0.03); }\n.log-table tr:last-child td { border-bottom: none; }\n.log-table .td-combo { color: var(--text-primary); font-style: italic; }\n.log-table .td-price { color: var(--gold); text-align: right; }\n.log-table .td-total { text-align: right; }\n\n/* ── Empty State ─────────────────────────────────────────────── */\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 5rem 2rem;\n  color: var(--text-muted);\n  text-align: center;\n}\n\n.empty-glyph {\n  width: 48px;\n  height: 48px;\n  border: 1px solid var(--border);\n  transform: rotate(45deg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.empty-glyph-inner {\n  width: 16px;\n  height: 16px;\n  background: var(--gold-dim);\n  opacity: 0.5;\n}\n\n.empty-state p {\n  font-style: italic;\n  font-size: 1rem;\n  max-width: 300px;\n}\n\n/* ── Spinner ─────────────────────────────────────────────────── */\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid var(--gold-dim);\n  border-top: 2px solid var(--gold-bright);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  display: inline-block;\n  margin-right: 8px;\n}\n\n/* ── Animations ──────────────────────────────────────────────── */\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.4; }\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* ── Responsive ──────────────────────────────────────────────── */\n@media (max-width: 720px) {\n  main { grid-template-columns: 1fr; }\n  .settings { border-right: none; border-bottom: 1px solid var(--border); }\n}\n\n.modal {\n  width: min(92vw, 420px);\n  background: var(--bg-surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 10px 40px rgba(0,0,0,0.5);\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.modal-title {\n  font-family: var(--font-display);\n  font-size: 1rem;\n  color: var(--gold);\n  letter-spacing: 0.08em;\n}\n.modal-desc {\n  font-size: 0.9rem;\n  color: var(--text-dim);\n}\n.modal input[type=\"text\"],\n.modal input[type=\"password\"] {\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n  border-radius: var(--radius);\n}\n.modal input::placeholder {\n  color: var(--text-muted);\n  opacity: 0.8;\n}\n.modal-desc { margin-bottom: 0.25rem; }\n.modal-error {\n  font-size: 0.85rem;\n  color: #e08080;\n  background: rgba(192,64,64,0.08);\n  border: 1px solid var(--red-dim);\n  border-radius: var(--radius);\n  padding: 0.5rem 0.6rem;\n}\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
